import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af7c85fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-container" }

import { computed, ref, watch } from "vue";
import { ScrollbarPosition } from "@/enums/system/ScrollbarPosition";
import { DxScrollView } from "devextreme-vue/scroll-view";


export default /*#__PURE__*/_defineComponent({
  __name: 'scroll-view',
  props: {
  /**
   * The boolean value indicates whether the component should reset the scroll position.
   * @type {boolean}
   * @default false
   */
  resetScroll: {
    type: Boolean,
    default: false,
  },

  /**
   * The boolean value indicates whether the component should automatically scroll to the bottom.
   * @type {boolean}
   * @default false
   */
  scrollToBottom: {
    type: Boolean,
    default: false,
  },

  /**
   * The CSS selector string for the scrollable element inside the component.
   * @type {string}
   * @default ''
   */
  scrollableElementSelector: {
    type: String,
    default: "",
  },

  /**
   * The direction of scrolling, either 'vertical' or 'horizontal'.
   * @type {string}
   * @default 'vertical'
   */
  scrollDirection: {
    type: String,
    default: "vertical",
  },

  /**
   * The boolean value indicates whether the component should hide the blur effect on the scroll content.
   * @type {boolean}
   * @default false
   */
  hideBlur: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:resetScroll"],
  setup(__props, { emit }) {

const props = __props;





const reset = computed({
  get: () => props.resetScroll,
  set: (value: Boolean) => emit("update:resetScroll", value),
});

const scrollPosition = ref<ScrollbarPosition>(ScrollbarPosition.Top);

// The value scrollPosition is based on the position the user is on in the scroll view to determine where the fade appears
const onScroll = () => {
  scrollPosition.value = ScrollbarPosition.Mid;
};

const onUpdated = (e: any) => {
  if (e.reachedTop && !e.reachedBottom) {
    scrollPosition.value = ScrollbarPosition.Top;
  } else if (e.reachedBottom && !e.reachedTop) {
    scrollPosition.value = ScrollbarPosition.Bottom;
  } else if (e.reachedBottom && e.reachedTop) {
    scrollPosition.value = ScrollbarPosition.None;
  }
};

/** Gets the class for fading content based on current scrollbar position */
const modalFadeClasses = computed(() => {
  if (props.hideBlur) {
    return "";
  }

  switch (scrollPosition.value) {
    case ScrollbarPosition.Top:
      return "atTop";
    case ScrollbarPosition.Bottom:
      return "atBottom";
    case ScrollbarPosition.Mid:
      return "midScroll";
    default:
      return "";
  }
});

// Watch for when parent wants to scroll back to the top of the view
watch(
  () => props.resetScroll,
  () => {
    if (!props.resetScroll || !dxScrollView.value?.instance) {
      return;
    }
    dxScrollView.value.instance.scrollTo(0);

    // Must always reset the v-model to false, otherwise subsequent resets won't fire
    reset.value = false;
  },
);

watch(
  () => props.scrollToBottom,
  (newVal: boolean, oldVal: boolean) => {
    // As content may load asynchronously, we need to continue scrolling until told to stop
    if (newVal) {
      scrollInterval.value = startAutoScroll();
      return;
    }

    /* When auto scroll is disabled, stop the interval running to avoid frustrating users
     * by resetting scroll position after manually scrolling */
    if (!newVal && oldVal && scrollInterval.value) {
      clearInterval(scrollInterval.value);
      return;
    }
  },
);

const scrollInterval = ref(0);

const startAutoScroll = () =>
  setInterval(() => {
    if (!props.scrollableElementSelector || !dxScrollView.value?.instance) {
      return;
    }

    const elem: HTMLDivElement | null = document.querySelector<HTMLDivElement>(
      props.scrollableElementSelector,
    );

    if (!elem) {
      return;
    }

    dxScrollView.value.instance.scrollTo(elem.scrollHeight);
  }, 250);

const dxScrollView = ref<DxScrollView>();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['scroll-container', modalFadeClasses.value])
  }, [
    _createVNode(_unref(DxScrollView), {
      scrollByThumb: true,
      scrollByContent: true,
      ref_key: "dxScrollView",
      ref: dxScrollView,
      height: "100%",
      width: "100%",
      onScroll: onScroll,
      onUpdated: onUpdated,
      direction: props.scrollDirection
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _: 3
    }, 8, ["direction"])
  ], 2))
}
}

})